<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <toolTip :maxWidth="'270px'" :title="statusLabel.title">
          <i class="icon iconfont iconicon_task_list"></i>
          {{statusLabel.title}}
        </toolTip>
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown">
        <el-dropdown-item
        v-for="item in dataset"
        :key="item.project_id"
        :command="item.project_id"
        >
        <toolTip :title="item.title"><span>{{item.title}}</span></toolTip>
          <i class="icon iconfont iconicon_selected_more_task" v-show="project_id === item.project_id"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import api from '@/services/api/mine/mine'
export default {
  data() {
    return {
      dataset: [],
      project_id: ''
    }
  },
  async created() {
    let params = {
      page: 1,
      number: 999,
    }
    let result = await api.relatedToMeProjectsIndex(params)
    this.dataset = result.data
    this.dataset.unshift({
      title: '所有项目',
      project_id: ''
    })
  },
  computed: {
    statusLabel() {
      return this.dataset.find(res => res.project_id === this.project_id) || {}
    }
  },
  methods: {
    handleCommand(val) {
      this.project_id = val
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss">
.filter-status {
}
</style>
